module.exports = __webpack_public_path__ + "static/media/fastway.7b7099d9.png";